/* eslint-disable react/jsx-props-no-spreading */
import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import { useField } from "formik";
import React from "react";

const CheckboxField = ({ name, label, ...other }) => {
  const [field, meta] = useField(name);
  const isInError = Boolean(meta.touched) && Boolean(meta.error);
  return (
    <FormControl error={isInError} {...other}>
      <FormControlLabel
        label={label}
        control={<Checkbox color="primary" checked={field.value} {...field} />}
      />
    </FormControl>
  );
};

export default CheckboxField;
